import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CardLayoutComponent } from '../shared/card-layout/card-layout.component';
import { Store } from '@ngrx/store';
import { FormattedValuePipe } from '../shared/pipes/formatted-value.pipe';

@Component({
    selector: 'app-fees',
    imports: [CardLayoutComponent],
    template: `
        <app-card-layout
            (click)="isActive = !isActive"
            [isActive]="isActive"
            title="Fees"
            icon="Fees-icon"
            subtitle="Fees"
            [isLoading]="isDCPolicyLoaded"
            [failed]="dcPolicyFailed"
            [fields]="fields"
            (retry)="retryDCPolicy()"
        ></app-card-layout>
    `,
})
export class FeesComponent {
    isActive = false;
    @Input() isDCPolicyLoaded = false;
    @Input() dcPolicyFailed = false;
    @Output() retry = new EventEmitter<void>();
    private formattedValuePipe = new FormattedValuePipe();
    private store = inject(Store);
    policySignal = this.store.selectSignal((state: any) => state.policy);

    get fields() {
        const policyState = this.policySignal();
        const policyNum = policyState.policyNumber;
        const data = policyState.data?.[policyNum]?.policySnapshot?.fees;
        if (!data) return [];
        // API returns [{ "status": "failed" }] when the fees service is unavailable.
        // Treat this as no data so the card shows the error state via dcPolicyFailed.
        if (Array.isArray(data) && data[0]?.status === 'failed') return [];
        return Object.values(data).map((v: any) => ({
            caption: v.feeType?.value,
            value: this.formattedValuePipe.transformCurrency(v.premium?.value) || '$00.0',
        }));
    }

    retryDCPolicy() {
        this.retry.emit();
    }
}
